export default process.env.REACT_APP_STRIPE_PUB_KEY;


// WEBPACK FOOTER //
// ./src/config/stripe.js